import { maxLengthRule } from '@/common/util/validations/main.js';


export function extraTextRulesDefault() {
    return {
        ...maxLengthRule(300),
    };
}
